import { apiClient } from "./client";

// ---- Professional side ----

/** Enable sharing. Returns { shareEnabled, shareToken }. */
export async function enableShare() {
  const res = await apiClient.post("/professional/share/enable", {});
  return res.data;
}

/** Disable sharing. Rotates the token. Returns { shareEnabled, shareToken }. */
export async function disableShare() {
  const res = await apiClient.post("/professional/share/disable", {});
  return res.data;
}

/** List recent view events (who has looked at the Professional's profile). */
export async function listShareViewEvents() {
  const res = await apiClient.get("/professional/share/view-events");
  return res.data;
}

// ---- Verifier side ----

/** Resolve a share token or canonical profile ID to the Professional's profile data. */
export async function resolveShare(tokenOrProfileId) {
  const res = await apiClient.get(
    `/share/${encodeURIComponent(tokenOrProfileId)}`,
  );
  return res.data;
}
